
import VueQrcode from '@chenfengyuan/vue-qrcode'
// import json from '../../eservice_user_json_mapping.json'
import config from '../../env.js';
import eServiceDataService from '@/services/eServiceDataService'

// var username = localStorage.getItem("username")      

export default {
    data() {
        return {
            // booklet: 'Booklet QR code',
            filename: '',
            value: '',
            size: 300,
            // testingvalue: this.getEncodeParam(localStorage.getItem("username")),
            home: '',
            booklet: '',
            user: '',
            lang: '',
            publicPath: process.env.BASE_URL
        }
    },
    methods: {
        baseUrl() {
          return process.env.VUE_APP_ENV === 'prod' ? config.prd_eservice_url : config.uat_eservice_url;
        },
        async getEncodeParam(){
            // var fileName = this.getDocMapping(user)
            var fileName = await this.getDocMapping()
            return btoa(fileName)
            // return encodeURIComponent(btoa(fileName))
        },
        // getDocMapping(username){
        async getDocMapping(){
            var name;
            var tmp = await eServiceDataService.getFilename()
            console.log(tmp)
            name = tmp.data.recordset[0].filename

            return name
        },
        viewpdf(file){
            //var path = (process.env.VUE_APP_ENV === 'prod' ? '/eservice_portal/' : (process.env.VUE_APP_ENV === 'test' ? '/' : '/spa/demo/eservice_portal_new/'))
            var filename = atob(file)
            var pdf = "./doc/doc/booklet/" + filename + ".pdf"
            this.checkFileExist(pdf)
        },
        checkFileExist(file){
            var xhr = new XMLHttpRequest()
            xhr.open('HEAD', file, false)
            xhr.send()

            console.log(xhr.status)

            var xRobotsTag = xhr.getResponseHeader('X-Robots-Tag')
            console.log('X-Robots-Tag:', xRobotsTag)
            if (!xRobotsTag) {
                console.warn('X-Robots-Tag header is missing for file:', file)
            }

            if(xhr.status == '404'){
                alert('File is not existed. Please help to check with IT')
            }else{
                //this.$router.push({ name: 'NewsPDF', params: { pdf: file } })
                window.open(file, '_blank')
            }
        },
    },
    components: {
        VueQrcode,
    },
    mounted: async function(){
        this.booklet = (localStorage.lang == 'en' ? 'Scan QR Code for Doctor List' : '掃碼下載醫生名單');
        this.home = (localStorage.lang == 'en' ? 'Home' : '主頁');
        this.filename = await this.getEncodeParam()
        this.value = this.baseUrl() + '/bookletpdf?pdf=' + this.filename
        // this.value = 'https://utltca01.qhms.com/spa/demo/eservice_portal_new/' + 'bookletpdf?pdf=' + this.filename
        this.user = localStorage.getItem("username")
        this.lang = localStorage.getItem("lang")
        this.dc_disclaimer = (localStorage.lang == 'en' ?'"For reference only, please contact the clinic to confirm the operating hour"':'"服務時間只供参考，詳情請聯絡診所"')
        console.log(this.value)
    }
}
